import { render, staticRenderFns } from "./element.vue?vue&type=template&id=019e0dc9&scoped=true&lang=pug"
import script from "./element.vue?vue&type=script&lang=js"
export * from "./element.vue?vue&type=script&lang=js"
import style0 from "./element.vue?vue&type=style&index=0&id=019e0dc9&prod&scoped=true&lang=css"
import style1 from "./element.vue?vue&type=style&index=1&id=019e0dc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019e0dc9",
  null
  
)

export default component.exports